import { Component } from '@angular/core';
import { CancellationReasonsCreateComponent } from "../../../../components/admin-dashboard-component/cancellation-reasons-component/cancellation-reasons-create-component/cancellation-reasons-create-component";

@Component({
  selector: 'app-cancellation-reasons-create',
  imports: [CancellationReasonsCreateComponent],
  templateUrl: './cancellation-reasons-create.html',
  styleUrl: './cancellation-reasons-create.scss',
})
export class CancellationReasonsCreate {

}
